import React from "react";
import { Route, Routes } from "react-router-dom";
import CheckListExecutionIndex from "../module/ChecklistExecution/checklistExecutionIndex";
import ConfigurationIndex from "../module/Configuration/configurationIndex";
import ChecklistBindingIndex from "../module/Binding/checklistBindingIndex";
import ProtectedRoute from "../../components/ProtectedRoute";

function CheckListBuilderRoutes() {
  return (
    <Routes>
      {/* Checklist execution */}
      <Route
        path="check-list/*"
        element={
          <ProtectedRoute menuKey="CHECKLIST">
            <CheckListExecutionIndex />
          </ProtectedRoute>
        }
      />

      {/* Templates configuration (Category removed) */}
      <Route
        path="configuration/*"
        element={
          <ProtectedRoute menuKey="CHECKLIST_CONFIG">
            <ConfigurationIndex />
          </ProtectedRoute>
        }
      />

      {/* Binding (Build) */}
      <Route
        path="binding/*"
        element={
          <ProtectedRoute menuKey="CHECKLIST_BINDING">
            <ChecklistBindingIndex />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default CheckListBuilderRoutes;